import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { SecurityContextType } from '../models/components/announcement.d';
import { GetActivitiesType } from '../models/enums/GetActivityType';
import { ActivityType } from '../models/components/lesson-upcoming-activity.d';
import { ISelect } from '../models/core/system-model';
import { Common } from '../core/common';
import { IActivityFilters } from '../models/action/coursePage';
import { GradeInfoTypes } from '../models/enums/GradeInfoTypes';

const token: any = localStorage.getItem('access_token');
const _logger = Log.create('CoursePage-Service');
const T = Translator.create();
let _apiClient: ApiClient;
let _common: Common;

export class CoursePageService {
    constructor() {
        _apiClient = new ApiClient();
        _common = new Common();
    }

    // Get Lesson-Page Header Information
    public async RequestGetCoursePageHeaderInfoAsync(classId: string, activityId: string) {
        return _apiClient
            .RequestAsync('POST', 'api/class/information', { ActivityId: activityId, ClassId: classId }, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_course_page_lessonHeaderInfo_error_message'),
                        'topRight'
                    );
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_course_page_lessonHeaderInfo_error_message'), 'topRight');
                return false;
            });
    }

    // Get Lesson Class Activity Progress
    public async RequestClassActivityProgressAsync(classId: string) {
        if (!classId) return false;
        return _apiClient
            .RequestAsync('POST', 'api/class/topcompletedactivity', { ClassId: classId, Take: 7, Skip: 0 }, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_course_page_lessonPage_activityProgress_error_message'),
                        'topRight'
                    );
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification(
                    'error',
                    T.t('r_course_page_lessonPage_activityProgress_error_message'),
                    'topRight'
                );
                return false;
            });
    }

    // Get Lesson Home Page Incoming Activities
    public async RequestIncomingActivitiesAsync(classId: string) {
        if (!classId) return false;
        return _apiClient
            .RequestAsync('GET', `api/class/${classId}/incomingactivity?Take=${7}&Skip=${0}`, null, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_course_page_lessonPage_inComing_activities_error_message'),
                        'topRight'
                    );
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification(
                    'error',
                    T.t('r_course_page_lessonPage_inComing_activities_error_message'),
                    'topRight'
                );
                return false;
            });
    }

    // Get Lesson Home Page Announcements
    public async RequestAnnouncementsAsync(classId: string, courseId: string, state: number) {
        if (!classId || !courseId) return false;
        const parsedUrl = new URL(window.location.href);

        if (parsedUrl.port === '' && parsedUrl.protocol === 'http:') {
            parsedUrl.port = '3000';
        } else if (parsedUrl.port === '' && parsedUrl.protocol === 'https:') {
            parsedUrl.port = '3000';
        }

        return _apiClient
            .RequestAsync(
                'POST',
                'api/announcement/announcements',
                {
                    items: [
                        {
                            ContextId: classId,
                            ContextType: SecurityContextType.Class,
                        },
                        {
                            ContextId: courseId,
                            ContextType: SecurityContextType.Course,
                        },
                    ],
                    State: state,
                    Take: 7,
                    Skip: 0,
                    Address: parsedUrl.hostname,
                    Port: parsedUrl.port,
                },
                token
            )
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_course_page_lessonPage_announcements_error_message'),
                        'topRight'
                    );
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification(
                    'error',
                    T.t('r_course_page_lessonPage_announcements_error_message'),
                    'topRight'
                );
                return false;
            });
    }

    // Get Lesson Home Page Current Week Activities
    public async RequestCurrentWeekActivitiesAsync(classId: string) {
        if (!classId) return false;
        return _apiClient
            .RequestAsync('GET', `api/class/${classId}/weekinformation?take=${7}&skip=${0}`, null, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestCourseClasses(courseId: string, take: number, skip: number, searchedText: string) {
        const emptyList: ISelect[] = new Array<ISelect>();
        return _apiClient
            .RequestAsync('POST', 'api/class/classes', {
                CourseId: courseId,
                SearchedText: searchedText,
                Take: take,
                Skip: skip,
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', T.t('bir sorun oluştu'), 'topRight');
                    return emptyList;
                } else {
                    return responseData.json();
                }
            })
            .then((result: ISelect[]) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification(
                    'error',
                    T.t('r_course_page_lessonPage_currentWeek_activities_error_message'),
                    'topRight'
                );
                return emptyList;
            });
    }

    // Get Lesson Home Page Current Week
    public async RequestGetCourseContentsWeeksAsync(classId: string) {
        if (!classId) return false;
        return _apiClient
            .RequestAsync('POST', 'api/term/courseweeks', { ClassId: classId }, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', T.t('bir sorun oluştu'), 'topRight');
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('Bir sorun oluştu'), 'topRight');
                return false;
            });
    }

    // Get Lesson Page Week Activities
    public async RequestGetCourseContentsWeeksActivitiesAsync(params: any) {
        const query = `${params.courseId}/${params.classId}?termWeekId=${params.termWeekId ? params.termWeekId : 0}&weekZero=${params.weekZero}&isWeekly=${params.isWeekly}&take=${params.take}&skip=${params.skip}&orderBy=${params.orderBy}`;
        return _apiClient
            .RequestAsync('GET', `api/activity/byweekactivity/` + query, null, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    // Get Activity Cards
    public async RequestGetActivityCardsAsync(param: {
        GetActivityType: GetActivitiesType;
        ClassId: string | null;
        CourseId: string;
        ActivityId: string | null;
        TermWeekId: string | null;
        Take: number;
        Skip: number;
        ContextId?: string;
        GetOnlyPassiveList?: boolean;//
        weekZero: boolean;
        activityFilters: IActivityFilters | null
    }) {
        return _apiClient
            .RequestAsync('POST', 'api/activity/activitylist', param, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    // Delete Activity
    public async RequestDeleteActivityAsync(param: {
        ActivityId: string;
        ClassId: string;
        CourseId: string;
        ActivityType: ActivityType;
    }) {
        let apiUrl = '';
        let apiParam;
        let queryParam = [];
        let method = 'POST';
        switch (param.ActivityType) {
            case ActivityType.Document:
                apiUrl = 'api/document/delete';
                apiParam = param;
                break;
            case ActivityType.Survey:
                apiUrl = 'api/survey/delete';
                apiParam = { activityId: param.ActivityId, classId: param.ClassId };
                break;
            case ActivityType.Video:
                apiUrl = 'api/video/delete';
                apiParam = { ActivityId: param.ActivityId, classId: param.ClassId };
                break;
            case ActivityType.Assignment:
                apiUrl = 'api/assignment/delete';
                apiParam = { activityId: param.ActivityId, classId: param.ClassId };
                break;
            case ActivityType.Elesson:
                apiUrl = 'api/elesson/delete';
                apiParam = { activityId: param.ActivityId, classId: param.ClassId };
                break;
            case ActivityType.VirtualClass:
                apiUrl = 'api/virtualclass/delete';
                apiParam = { activityId: param.ActivityId, classId: param.ClassId };
                break;
            case ActivityType.LinkActivity:
                apiUrl = 'api/link/delete';
                apiParam = { activityId: param.ActivityId, classId: param.ClassId };
                break;
            case ActivityType.Exam:
                apiUrl = 'api/exam/delete';
                apiParam = { activityId: param.ActivityId, classId: param.ClassId };
                break;
            case ActivityType.Forum:
                queryParam = [{ key: 'threadId', value: '' }, { key: 'activityId', value: param.ActivityId }, { key: 'classId', value: param.ClassId }];
                apiUrl = _common.StringFormat('api/forum?threadId={threadId}&activityId={activityId}&classId={classId}', queryParam);
                method = 'DELETE';
                break;
            case ActivityType.Project:
                apiUrl = `api/project/${param.CourseId}/${param.ClassId}/${param.ActivityId}`;
                apiParam = { activityId: param.ActivityId, classId: param.ClassId };
                method = 'DELETE';
                break;
            case ActivityType.LTIActivity:
                apiUrl = 'api/lti/delete';
                apiParam = { ActivityId: param.ActivityId, ClassId: param.ClassId };
                break;
            case ActivityType.InformationNote:
                apiUrl = 'api/informationnote/delete';
                apiParam = { ActivityId: param.ActivityId, ClassId: param.ClassId };
                break;
            default:
                break;
        }
        return _apiClient
            .RequestAsync(method, apiUrl, apiParam, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    // Get course content menu
    public async RequestGetCourseContentMenuAsync(param: { ClassId: string, CourseId: string }) {
        return _apiClient
            .RequestAsync('POST', 'api/activity/contentpagemenu', param, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetActivityIdsByWeeksAsync(param: { ClassId: string, IsCache?: boolean, CourseId: string }) {
        return _apiClient
            .RequestAsync('POST', 'api/activity/activityidsbyweeks', param, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetCourseStudentListAsync(param: { ClassId: string }) {
        return _apiClient
            .RequestAsync('POST', 'api/class/getstudents', param, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', T.t('bir sorun oluştu'), 'topRight');
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('Bir sorun oluştu'), 'topRight');
                return false;
            });

    }

    public async RequestGetProgressPercentAsync(param: { ClassId: string, UserId: string }) {
        return _apiClient
            .RequestAsync('POST', 'api/enrollment/getProgressPercent', param, token)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification('error', T.t('r_error_get_progress_percent'), 'topRight');
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_error_get_progress_percent'), 'topRight');
                return false;
            });
    }

    public async RequestGetCourseFilesAsync(params: any) {
        const queryParam = [
            { key: 'page', value: params.page },
            { key: 'take', value: params.take },
            { key: 'query', value: params.query },
            { key: 'orderBy', value: params.orderBy },
            { key: 'uploadRelationType', value: params.uploadRelationType },
            { key: 'courseId', value: params.courseId }
        ];

        return _apiClient
            .RequestAsync('GET', _common.StringFormat('api/class/' + params.classId + '/file?courseId={courseId}&page={page}&skip={skip}&take={take}&query={query}&orderBy={orderBy}&uploadRelationType={uploadRelationType}', queryParam), null, token)
            .then((response: Response) => {
                return response;
            }).catch((response) => {
                return response;
            });
    }

    public async RequestGetCourseClassActivityReportAsync(params: any) {
        return _apiClient
            .RequestAsync('GET', `api/report/${params.classId}/activity/${params.activityId}/${params.groupId}`, null, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestClassActivityReportDownload(param: { ClassId: string; ActivityId: string }) {
        return _apiClient
            .RequestAsync('POST', 'api/report/download', param, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    Notification.setNotification(
                        'info',
                        'Raporunuz hazırlanıyor. İndirmeye hazır olduğunda bildirim alacaksınız.',
                        'topRight'
                    );
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('Bir sorun oluştu'), 'topRight');
                return false;
            });
    }

    public async RequestAssignmentGradeInformation(param: { classId: string; activityId: string; groupId: string }) {
        return _apiClient
            .RequestAsync('GET', 'api/assignment/gradeInformation' + '/' + param.classId + '/' + param.activityId + '/' + param.groupId, null, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_assignment_grade_information_error_message'), 'topRight');
                return false;
            });
    }

    public async RequestAssignmentGradeStudentList(params: { classId: string; activityId: string, page: string, gradeInfoType: GradeInfoTypes, groupId: string; take: number, query: string }) {
        return _apiClient
            .RequestAsync('GET', 'api/assignment/studentList' + '/' + params.classId + '/' + params.activityId + '?page=' + params.page + '&take=' + params.take + '&query=' + params.query + '&groupId=' + params.groupId + "&gradeInfoType=" + params.gradeInfoType, null, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                return false;
            });
    }

    public async RequestAssignmentGradeSaveGrade(param: { ClassId: string; ActivityId: string }) {
        return _apiClient
            .RequestAsync('POST', 'api/assignment/saveGrade', param, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_assignment_grade_save_grade_error_message'), 'topRight');
                return false;
            });
    }

    public async RequestAssignmentGradeDownloadAllGrades(param: { ClassId: string; ActivityId: string }) {
        return _apiClient
            .RequestAsync('POST', 'api/assignment/downloadAll', param, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_assignment_grade_download_all_error_message'), 'topRight');
                return false;
            });
    }
    public async RequestAssignmentBulkGrade(param: { ClassId: string; ActivityId: string; Score?: string }) {
        return _apiClient
            .RequestAsync('POST', 'api/assignment/bulkGrade', param, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    Notification.setNotification('success', T.t('r_assignment_bulk_grade_succes_message'), 'topRight');
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification('error', T.t('r_assignment_bulk_grade_error_message'), 'topRight');
                return false;
            });
    }

    public async RequestGetMyActivityStastAsync() {
        return _apiClient.RequestAsync('GET', 'api/activity/mystats', null, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }
    public async RequestGetActivityStatusAsync(params: { ActivityId: string; Status: number; }) {
        return _apiClient.RequestAsync('POST', 'api/activity/updatestatus', params, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }
    public async RequestUpdateInputAsync(params: any) {
        return _apiClient.RequestAsync(params.apiMethod, params.apiUrl, params, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetActivityReportDetail(param: { ClassId: string; ActivityId: string; }) {
        return _apiClient.RequestAsync('POST', 'api/activity/reportDetail', param, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestClearCourseCacheData(param: { ClassId: string; CourseId: string; }) {
        return _apiClient.RequestAsync('POST', 'api/activity/clearCache', param, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestCourseTeacherAndStudentClasses(params: { courseId: string, filters: { page: number, take: number } }) {
        return _apiClient
            .RequestAsync('POST', 'api/course/getteacherandstudentcourse', { CourseId: params.courseId, take: params.filters.take, page: params.filters.page }, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch((responseData) => {
                return responseData;
            });
    }

    public async RequestTriggerCourseStar(param: { CourseId: string }) {
        return _apiClient
            .RequestAsync('POST', 'api/course/coursestar', param, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch((responseData) => {
                return responseData;
            });
    }

    public async RequestRemovePrerequisite(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/activity/removeprerequisite', params, token)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch((responseData) => {
                return responseData;
            });
    }

}
